import { render, staticRenderFns } from "./view.html?vue&type=template&id=5261d922&scoped=true&"
import script from "./view.js?vue&type=script&lang=js&"
export * from "./view.js?vue&type=script&lang=js&"
import style0 from "./view.scss?vue&type=style&index=0&id=5261d922&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5261d922",
  null
  
)

export default component.exports